// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"8a4ef70a","681":"d152aec7","940":"31d6cfe0"}[chunkId] + ".chunk.css";
};